import { render, staticRenderFns } from "./PwReset.vue?vue&type=template&id=ca3aa7aa&scoped=true&"
import script from "./PwReset.vue?vue&type=script&lang=js&"
export * from "./PwReset.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.css?vue&type=style&index=0&id=ca3aa7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3aa7aa",
  null
  
)

export default component.exports